<template>
	<Row class="hero ivu-text-center">
		<Col span="24">
		<Title><span style="color: #2b85e4;">{{this.$store.getters.getConfig.sitename}}</span>工具团购</Title>
		<Title :level="3">{{this.$store.getters.getConfig.subtitle}}</Title>
		</Col>
	</Row>
	<br>
	<ProductList></ProductList>
</template>

<script>
	import ProductList from '@/components/ProductList.vue'
	export default {
		name: 'HomeView',
		components: {
			ProductList
		}
	}
</script>

<style>
	.hero {
		background-color: rgb(239, 245, 251);
		padding: 80px;
	}
</style>